import { useEffect } from 'react';
import { Navigate } from 'react-router';
import { Page } from '@bonanza-social/navigation';
import { useDispatch, useSelector } from '@bonanza-social/toolkit/state';
import { Box, Loader } from '@bonanza-social/moonlight';
import {
  fetchPrizeWall,
  selectPrizeWallDataState,
} from '../state/prizeWall/prizeWall.slice';
import { selectPrizeWallCampaignDataState } from '../state/prizeWallCampaign/prizeWallCampaign.slice';
import PrizeWallWinnersBackground from '../components/PrizeWallWinners/PrizeWallWinnersBackground/PrizeWallWinnersBackground';
import PrizeWallWinnersHeader from '../components/PrizeWallWinners/PrizeWallWinnersHeader/PrizeWallWinnersHeader';
import PrizeWallWinners from '../components/PrizeWallWinners/PrizeWallWinners';

function PrizeWallWinnersPage() {
  const dispatch = useDispatch();
  const campaignDataState = useSelector(selectPrizeWallCampaignDataState);
  const wallDataState = useSelector(selectPrizeWallDataState);

  useEffect(() => {
    if (
      campaignDataState === 'fulfilled' &&
      (wallDataState === 'idle' || wallDataState === 'rejected')
    ) {
      dispatch(fetchPrizeWall());
    }
  }, [campaignDataState, wallDataState, dispatch]);

  return (
    <Page>
      {(campaignDataState === 'pending' || wallDataState === 'pending') && (
        <Loader margin="auto" />
      )}
      {(campaignDataState === 'rejected' || wallDataState === 'rejected') && (
        <Navigate to="/" replace />
      )}
      {campaignDataState === 'fulfilled' && wallDataState === 'fulfilled' && (
        <Box width="100%">
          <PrizeWallWinnersBackground contentFit="fill" />
          <Box width="100%" height="100%">
            <PrizeWallWinnersHeader width="100%" />
            <PrizeWallWinners
              width="100%"
              margin="auto"
              paddingVertical="space-1000"
              maxWidth={576}
            />
          </Box>
        </Box>
      )}
    </Page>
  );
}

export default PrizeWallWinnersPage;
